import {Container} from "./styled";
import {useAppSelector} from "hooks";
import {Column, Row, Typography} from "components";

interface InfoProps {}

export const Info: React.FC<InfoProps> = () => {
  const {client} = useAppSelector("clients");
  const {nombre, apellido, cedula, direccion, telefono, fecha_nac} = client;
  return (
    <Container>
      <Column>
        <Column>
          <Row display="grid" gridTemplateColumns="80px 1fr" gap="2rem">
            <Typography fontSize={14} fontFamily="Rubik-Medium">
              Nombre
            </Typography>
            <Typography>
              {nombre} {apellido}
            </Typography>
          </Row>
          <Row display="grid" gridTemplateColumns="80px 1fr" gap="2rem">
            <Typography fontSize={14} fontFamily="Rubik-Medium">
              Cédula
            </Typography>
            <Typography>{cedula}</Typography>
          </Row>
          <Row display="grid" gridTemplateColumns="80px 1fr" gap="2rem">
            <Typography fontSize={14} fontFamily="Rubik-Medium">
              Teléfono
            </Typography>
            <Row>
              <Typography>{telefono}</Typography>
            </Row>
          </Row>
          <Row display="grid" gridTemplateColumns="80px 1fr" gap="2rem">
            <Typography fontSize={14} fontFamily="Rubik-Medium">
              Nacimiento
            </Typography>
            <Typography>{fecha_nac}</Typography>
          </Row>
          <Row display="grid" gridTemplateColumns="80px 1fr" gap="2rem">
            <Typography fontSize={14} fontFamily="Rubik-Medium">
              Dirección
            </Typography>
            <Typography>{direccion}</Typography>
          </Row>
        </Column>
      </Column>
    </Container>
  );
};
